// Signup policy + the access-request workflow. New Google accounts land in the
// `members` registry as `pending`; the admin approves here, which mints a
// one-time 16-hex activation key and emails it to them (Twilio SendGrid) with a
// copy to the administrator. The member enters it in the app to activate.
import { callAdmin } from './adminApi';

export interface SignupConfig {
  inviteOnly: boolean;
  updatedAt: number;
  emailConfigured: boolean;    // false → the console falls back to manual delivery
}

export interface ApproveResult { code: string; emailed: boolean }

export const getSignup = () => callAdmin<SignupConfig>('getSignup');
export const setSignup = (c: { inviteOnly: boolean }) => callAdmin('setSignup', c);

/** Approve a request (or re-issue for an already-approved member): mints + sends a new key. */
export const approveMember = (email: string) => callAdmin<ApproveResult>('approve', { email });
/** Decline a request — removes the registry entry and revokes any access. */
export const declineMember = (email: string) => callAdmin('remove', { email });
